/**
 * 判断测试数据是否为 String 类型数据
 * ========================================================================
 * @method isString
 * @param {String} str - 测试数据
 * @return {Boolean}
 */
const isString = (str) => {
  return typeof str === 'string'
}

export default isString
